import React from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { ArrowForward } from "components/Icons";
import CorneredCard from "components/CorneredCard";

import "./ToggleCard.scss";

interface IProps {
  title: string;
  children: string | JSX.Element;
}

interface IState {
  toggled: boolean;
}

class ToggleCard extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = { toggled: false };
  }

  public render() {
    const { title, children } = this.props;
    const { toggled } = this.state;

    return (
      <CorneredCard className="toggle-card">
        <div
          id={_.lowerCase(title)}
          className="header"
          onClick={() =>
            this.setState(prevState => ({ toggled: !prevState.toggled }))
          }
        >
          <FormattedMessage id={title} tagName="label" />
          <ArrowForward className={classnames(toggled ? "down" : "")} />
        </div>
        <div className={classnames("text", !toggled ? "closed" : "")}>
          {children}
        </div>
      </CorneredCard>
    );
  }
}

export default ToggleCard;
